import React from 'react';
import { useTranslation } from 'react-i18next';

import { LucideNavIcons } from '../../../icons/lucideNavIcons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

import scss from '../project-name-header/ProjectNameHeader.module.scss';

function AiPlaygroundHeader() {
  const { t } = useTranslation('header');
  return (
    <ProjectNameHeader
      icon={LucideNavIcons.AiPlayground}
      selector={() => null}
      defaultName={t('aiPlayground')}
      iconProps={{ disableCommonStyles: true, className: scss.iconStroke }}
    />
  );
}

export default AiPlaygroundHeader;
